import { Link } from "react-router-dom";
import { Shield, Heart, Home, CheckCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function SuccessPage() {
  return (
    <div className="min-h-screen gradient-hero flex flex-col">
      {/* Header */}
      <header className="px-6 md:px-12 lg:px-24 py-6">
        <nav className="flex items-center justify-center">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="mobbing-melden.de Logo" 
              className="h-14 w-auto"
            />
          </Link>
        </nav>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-2xl mx-auto text-center animate-fade-in-up">
          {/* Success Icon */}
          <div className="w-32 h-32 bg-[#A0E8AF]/30 rounded-full flex items-center justify-center mx-auto mb-8 animate-float">
            <div className="w-24 h-24 bg-[#A0E8AF] rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-[#1A4731]" strokeWidth={2} />
            </div>
          </div>

          <h1 
            className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#2D3748] mb-6"
            style={{ fontFamily: 'Nunito' }}
            data-testid="success-title"
          >
            Danke, dass du dich gemeldet hast!
          </h1>

          <p className="text-lg md:text-xl leading-relaxed text-[#718096] mb-8 max-w-xl mx-auto">
            Deine Nachricht ist bei uns angekommen. Du hast das Richtige getan, indem du 
            uns erzählt hast, was passiert ist.
          </p>

          {/* Info Card */}
          <div className="card-base bg-gradient-to-br from-[#E6FFFA] to-[#FFF5F7] border-0 text-left mb-10">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center flex-shrink-0">
                <Heart className="w-6 h-6 text-[#FFC4D6]" strokeWidth={2} />
              </div>
              <div>
                <h3 
                  className="text-xl font-bold text-[#2D3748] mb-2"
                  style={{ fontFamily: 'Nunito' }}
                >
                  Was passiert jetzt?
                </h3>
                <ul className="text-[#718096] space-y-2">
                  <li className="flex items-start gap-2">
                    <span className="text-[#A0E8AF]">✓</span>
                    <span>Unser Team wird deinen Fall so schnell wie möglich prüfen</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#A0E8AF]">✓</span>
                    <span>Wenn du Kontaktdaten angegeben hast, melden wir uns bei dir</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-[#A0E8AF]">✓</span>
                    <span>Bei schweren Fällen können wir die Behörden einschalten</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Encouragement */}
          <div className="mb-10">
            <p 
              className="text-2xl font-bold text-[#2D3748]"
              style={{ fontFamily: 'Nunito' }}
            >
              Du bist mutig! 💪
            </p>
            <p className="text-[#718096]">
              Es braucht viel Stärke, über solche Dinge zu sprechen.
            </p>
          </div>

          {/* Back Home Button */}
          <Link to="/">
            <Button 
              className="btn-primary text-lg px-10 py-5"
              data-testid="back-home-button"
            >
              <Home className="w-5 h-5 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 md:px-12 lg:px-24 py-6 text-center">
        <p className="text-sm text-[#A0AEC0]">
          Wenn du sofort Hilfe brauchst, wende dich an die <strong>Nummer gegen Kummer: 116 111</strong>
        </p>
      </footer>
    </div>
  );
}
